/**
 * Pricing calculation utilities for the embed pricing calculator
 */

/**
 * Calculate total monthly cost: subscription fee + (bookings * platform fee per ride)
 * @param subscriptionFeeInCents - Base subscription fee in cents
 * @param platformFeePerRideInCents - Platform fee per ride in cents
 * @param monthlyBookings - Number of monthly bookings
 * @returns Total monthly cost in dollars
 */
export const calculateTotalMonthlyCost = (
  subscriptionFeeInCents: number,
  platformFeePerRideInCents: number,
  monthlyBookings: number
): number => {
  return (subscriptionFeeInCents + monthlyBookings * platformFeePerRideInCents) / 100;
};

/**
 * Format cents to dollar string
 * @param cents - Amount in cents
 * @returns Formatted dollar string (e.g., "$5.50")
 */
export const formatCentsToDollars = (cents: number): string => {
  return `$${(cents / 100).toFixed(2)}`;
};

/**
 * Format booking value for display
 * @param value - Number of bookings
 * @returns Formatted string (e.g., "50,000+")
 */
export const formatBookingValue = (value: number): string => {
  if (value >= 50000) return "50,000+";
  return value.toLocaleString();
};

export const MIN_BOOKINGS = 0;
export const MAX_BOOKINGS = 50000;
